module.exports = __webpack_public_path__ + "static/media/cszc.bf448e3c.mp4";